import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './near-by.component';
import { ParadasComponent } from './paradas/paradas.component';

@NgModule({
  declarations: [
    AppComponent,
    ParadasComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule
  ],
  providers: [],
  bootstrap: [ AppComponent ],
  entryComponents: [ ParadasComponent ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/near-by.module.ts